global.selectizeInit = function() {
  jQuery('.selectize').selectize({});
  jQuery('.selectize-with-create').selectize({
    create: true,
    silent: true
  });
};

$(document).on('turbolinks:load', selectizeInit);
